const IMAGES = [
  require(`./assets/01.jpg`),
  require(`./assets/02.jpg`),
  require(`./assets/03.jpg`),
  require(`./assets/04.jpg`),
  require(`./assets/05.jpg`),
  require(`./assets/06.jpg`),
  require(`./assets/07.jpg`),
  require(`./assets/08.jpg`),
  require(`./assets/09.jpg`),
  require(`./assets/010.jpg`),
  require(`./assets/011.jpg`),
  require(`./assets/batch2/01.jpg`),
  require(`./assets/batch2/02.jpg`),
  require(`./assets/batch2/03.jpg`),
  require(`./assets/batch2/04.jpg`),
  require(`./assets/batch2/05.jpg`),
  require(`./assets/batch2/06.jpg`),
  require(`./assets/batch2/07.jpg`),
  require(`./assets/batch2/08.jpg`),
  require(`./assets/batch2/09.jpg`),
]

const selectImages = (count: number) => {
  let stack = IMAGES.slice()
  let output = [] as typeof stack

  for (let i = 0; i < count; i++) {
    const randomIndex = Math.round(Math.random() * (stack.length - 1))
    output.push(stack[randomIndex])
    stack = [...stack.slice(0, randomIndex), ...stack.slice(randomIndex + 1)]
  }

  return output
}

export const NUMBER_OF_ITEMS = 6
export const SELECTED_IMAGES = selectImages(10)
